import { KEYCLOAK_STORAGE_ACCESS_TOKEN } from 'constants/keycloakConstants'
import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'

/**
 * Composant qui permet de gérer les routes non authentifiées
 *
 * @param {Object} props Les props
 * @param {Object} props.component Le composant à afficher
 * @param {string} props.path Le chemin de la route
 * @returns {React.Component} Le composant
 */
const UnAuthenticatedRoute = ({ component, path }) => {
  const user = useSelector((state) => state.userReducer.user)
  const currentRoute = window.location.pathname

  const loggedIn = user && user.id && localStorage.getItem(KEYCLOAK_STORAGE_ACCESS_TOKEN)

  if (loggedIn && currentRoute === path) {
    return <Redirect to="/accueil" />
  }

  return currentRoute !== path ? <></> : <Route path={path} render={() => component} />
}
export default UnAuthenticatedRoute
